import React from 'react';
import { Steps, Button } from 'antd';

import './Progress.scss';

class Progress extends React.Component {
  state = {
    progressEl: null,
    scroll: 0,
    totalWidth: 0,
  };

  componentDidMount() {
    const el = document.querySelector('#progress-inner');
    this.setState({
      progressEl: el,
      totalWidth: el.scrollWidth - el.offsetWidth,
    });
  }

  handleScrollLeft = () => {
    const { scroll, progressEl } = this.state;
    let newScroll = scroll + progressEl.offsetWidth;

    if (newScroll >= 0) {
      newScroll = 0;
    }

    this.setState({ scroll: newScroll });
  };

  handleScrollRight = () => {
    const { scroll, totalWidth, progressEl } = this.state;
    let newScroll = scroll - progressEl.offsetWidth;

    if (Math.abs(newScroll) >= totalWidth) {
      newScroll = -totalWidth;
    }

    this.setState({ scroll: newScroll });
  };

  render() {
    const { scroll, totalWidth } = this.state;

    return (
      <div className="form-progress">
        {scroll !== 0 && (
          <Button
            shape="circle"
            icon="left"
            size="large"
            onClick={this.handleScrollLeft}
          />
        )}
        <Steps
          current={-1}
          id="progress-inner"
          style={{ transform: `translate3d(${scroll}px, 0px, 0px)` }}
        >
          <Steps.Step
            status="finish"
            title="Appointment Requested"
            description={
              <div>
                <span>PIC 2: Thomas Hiep Pham</span>
                <br />
                <span>03-12-2020</span>
              </div>
            }
          />
          <Steps.Step
            status="process"
            title="Appointment Confirmed"
            description={
              <div>
                <span>PIC 2: Thomas Hiep Pham</span>
                <br />
                <span>03-12-2020</span>
              </div>
            }
          />
          <Steps.Step
            title="Paperwork Sent to Specialist"
            description={
              <div>
                <span>PIC 2: Thomas Hiep Pham</span>
                <br />
                <span>03-12-2020</span>
              </div>
            }
          />
          <Steps.Step
            title="Attended"
            description="PIC 4: Staff Collette"
          />
          <Steps.Step
            title="Did Not Attend"
            description="PIC 4: Staff Collette"
          />
          <Steps.Step
            title="Prepayment Required"
            description="PIC: Staff Bonaccorsi"
          />
          <Steps.Step
            title="Prepayment Paid"
            description="PIC: Staff Bonaccorsi"
          />
          <Steps.Step
            title="Dictation Received"
            description="PIC 5: Mag Reports"
          />
          <Steps.Step
            title="Report Draft Sent to Specialist"
            description="PIC 6: Mag Reports"
          />
          <Steps.Step
            title="Report Returned from Specialist"
            description="PIC 7: Mag Reports"
          />
          <Steps.Step
            title="Report Sent to CMs"
            description="PIC 9: Mag Reports"
          />
          <Steps.Step title="Cancelled - No Fee" />
          <Steps.Step
            title="Service Billed"
            description="PIC 9: Staff Bonaccorsi"
          />
        </Steps>
        {!(Math.abs(scroll) >= totalWidth) && (
          <Button
            shape="circle"
            icon="right"
            size="large"
            onClick={this.handleScrollRight}
          />
        )}
      </div>
    );
  }
}

export default Progress;
